import ConnectedAccountsSection from '../../components/connected-accounts-section.tsx';
import { AccountSettingsFrame } from './account.tsx';

/**
 * /settings/connected-accounts: the providers this person signs in with.
 * A link round trip returns here, so the outcome banner reads on this page.
 * The password form is on the account page, so "Set a password" goes there.
 */
export default function ConnectedAccountsPage() {
  return (
    <AccountSettingsFrame current="connectedAccounts">
      <ConnectedAccountsSection
        returnTo="/settings/connected-accounts"
        passwordTo="/settings/account#password-heading"
      />
    </AccountSettingsFrame>
  );
}
